import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { VideoPlayerRoot, VideoPlayerInput } from "./VideoPlayer.styles";
import { useRouteParams } from "../../context/RouteParamsContext";

export const VideoPlayer = ({ sources, poster, id }) => {
  const { projectName } = useRouteParams();

  return (
    <VideoPlayerRoot
      component="video"
      autoPlay
      loop
      muted
      playsInline
      poster={poster}
      id={id}
      sx={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        backgroundColor: "#000",
      }}
    >
      {sources.map((src, idx) => (
        <source key={idx} src={src.url} type={src.type} />
      ))}
      Your browser does not support the video tag.
    </VideoPlayerRoot>
  );
};
